exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  height: 100%;\n  overflow-y: auto;\n  font-family: 'Calibri', 'Arial', sans-serif;\n  font-size: 1rem;\n  color: #000; }\n  :host * {\n    box-sizing: border-box; }\n\n.cd-denied {\n  padding: 20px 10px;\n  color: #6c757d; }\n\n.cd-main {\n  min-width: 0;\n  padding: 5px 10px 16px;\n  background: #fff;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 12px; }\n\n.cd-charts {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: minmax(0, 1.8fr) minmax(0, 1fr);\n      grid-template-columns: minmax(0, 1.8fr) minmax(0, 1fr);\n  gap: 12px;\n  height: 420px; }\n\n.cd-rankings {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: minmax(0, 1.25fr) minmax(0, 1.25fr) minmax(0, 1fr);\n      grid-template-columns: minmax(0, 1.25fr) minmax(0, 1.25fr) minmax(0, 1fr);\n  gap: 12px; }\n\n.cd-empty {\n  padding: 24px;\n  text-align: center;\n  color: #6c757d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-dashboard/complaints-dashboard.component.scss
// module id = 1991
// module chunks = 66